import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Rocket } from "lucide-react";
import { getProjects } from "../../redux/actionCreator";
import { project_data } from "../../redux/commonReducer";
import DeployPage from "./DeployPage";
import "./deployPage.scss";

/**
 * Sidebar entry for deployments. Pick a project, then the full project-level
 * deploy UI (config / run / history) renders inline for it. Mirrors the
 * Docker page's selector pattern; the per-project `/deploy/:projectId` route
 * still works for deep links.
 */
export default function DeployHome() {
  const dispatch = useDispatch();
  const projects = useSelector(project_data) || [];
  const [projectId, setProjectId] = useState("");

  useEffect(() => {
    dispatch(getProjects({ page: 0, limit: 200 }));
  }, [dispatch]);

  return (
    <div className="deploy-home">
      <div className="deploy-home-head">
        <h2 className="m-0 d-inline-flex align-items-center gap-2"><Rocket size={22} /> Deploy</h2>
        <select
          className="form-select form-select-sm"
          value={projectId}
          onChange={(e) => setProjectId(e.target.value)}
        >
          <option value="">— Select project —</option>
          {projects.map((p) => (
            <option key={p._id} value={p._id}>{p.project_name || p.name}</option>
          ))}
        </select>
      </div>

      {!projectId ? (
        <div className="deploy-home-empty">
          <div className="empty-art"><Rocket size={32} strokeWidth={1.2} /></div>
          <h4>Pick a project to deploy</h4>
          <p>Select a project above to configure its deployment, push an image or build from Git, and review deploy history.</p>
        </div>
      ) : (
        // `key` forces a fresh mount when the project changes so all the
        // internal config/history state resets cleanly.
        <DeployPage key={projectId} projectId={projectId} />
      )}
    </div>
  );
}
